import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';

//COMPONENTS
import { Row, Column, IBox, Icon, Return, TextArea } from '../inspinia'
import TagSelectorHTML from '../tagSelectorHTML';
import ModalPreview from '../campanha/modalPreview'
import ModalSendTest from '../campanha/modalSendTest'
import TemplateSelector from '../templateSelector';
import UrlCampanhaSms from './urlCampanhaSms';
import {SMS} from '../../store/tipoListaEmail';

class NovaEditorSms extends React.PureComponent {
    constructor(props) {
        super(props);

        const initialForm = this.formInitialState();

        const empresaDaUrl = props.location.state?.empresa;
        if (empresaDaUrl) {
        initialForm.empresa = empresaDaUrl;
        }

        this.state =
        {
            loading: false,
            form: initialForm,
            modalPreviewIsOpen: false,
            modalSendTestIsOpen: false,

            //Utilizado para recuperar as informações o ID da Campanha
            idCampanha: this.props.campanha.idCampanha,
            emailUsuario: this.props.auth.user.email,
            usuario: {},
            auth: this.props.auth,
            posicaomouse1: [],
            posicaomouse2: [],
            tipoSalvar: "", 
            templateAntigo: "",
            maxLength: "160",

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.handleChangeText = this.handleChangeText.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeAssunto = this.handleChangeAssunto.bind(this);
        this.handlePreviewToggle = this.handlePreviewToggle.bind(this);
        this.handleTestToggle = this.handleTestToggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.click = this.click.bind(this);
        this.insereTemplate = this.insereTemplate.bind(this);
        this.handleChangeUrl = this.handleChangeUrl.bind(this);
        this.defineMaxLenth = this.defineMaxLenth.bind(this);

        this.state.usuario['email'] = this.state.emailUsuario;

    }

    formInitialState() {

        return {

            id: "",
            template: [],
            url: "",
            mensagem: "",
            nome: "",
            empresa: {},
            assunto: "",
        }
        
    }

    componentDidMount() {        

        const empresa = this.props.location.state?.empresa;
        if (empresa) {
            this.setState(prev => ({
                form: {
                    ...prev.form,
                    empresa: empresa
                }
            }));
        }

        this.RecuperarTemplates();
        this.RecuperarIdCampanhaEditar();

    }

    insereTemplate(states, id, comp) {
        let self = this;
        comp.preventDefault();

        const url = `${c.API_CAMPAIGN_URL}/template/${id}`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        callApi(url, options, (response) => {
                    this.setState(prev => ({
                      form: {
                        ...prev.form,          
                        id: response.id,
                        nome: response.nome,
                        mensagem: response.mensagem,
                        assunto: response.assunto,
                        url: response.url ? response.url : "",                      }
                    }));
                  });

    }

    RecuperarTemplates() {
        let self = this;

        const empresa = this.state.form.empresa.id;

        const url = `${c.API_CAMPAIGN_URL}/template-SMS/${empresa}?page=0&size=1000`;
        const options = self.state.optionsGet;

        callApi(url, options, (response) => {
                    this.setState({
                      templates: response.content  
                    });
                  });
    }

    RecuperarIdCampanhaEditar() {
            const idCampanha = this.state.idCampanha;
            const url = `${c.API_CAMPAIGN_URL}/template-campanha/${idCampanha}`;
            callApi(url, this.state.optionsGet, (response) => {
                this.setState(({ form }) => ({
                    form: {
                        ...form,
                        id: response.id,
                        nome: response.nome,
                        mensagem: response.mensagem,
                        assunto: response.assunto,
                        url: response.url
                    }
                }));
            });
        }

    handlePreviewToggle(e) {
        this.setState({ ...this.state, modalPreviewIsOpen: !this.state.modalPreviewIsOpen });
    }

    handleTestToggle(e) {
        this.setState({ ...this.state, modalSendTestIsOpen: !this.state.modalSendTestIsOpen });
    }

    handleSave(e) {
        e.preventDefault(); if (this.state.loading) return;

        let self = this;

        this.setState({ tipoSalvar: e.target.name });
        this.state.form.auth = this.state.auth;
        let idCampanha = this.state.idCampanha;
        let editor = 'html';
        let tipoTemplate = SMS;

        let idArquivoTemplate = '';
        
        this.props.actions.campanha.salvarTemplate(this.state.form, idCampanha, editor, idArquivoTemplate,tipoTemplate).then((response) => {
            if (response.status === "BAD_REQUEST") {
                c.TOASTER_SUCCESS(response.message);
                return;
            }

            if (response) {
                c.TOASTER_SUCCESS("Template salvo com sucesso!");

                if (self.state.tipoSalvar !== "salvarcontinuar") {
                    c.TOASTER_SUCCESS("Campanha salva com sucesso!");
                    self.props.history.push(c.PANEL_ROUTE);

                } else if (self.state.tipoSalvar === "salvarcontinuar") {
                    self.props.campanha.template = self.state.form.mensagem;
                    self.props.history.push(c.CAMPAIGN_ROUTE + "/nova-sms/checklist");

                }
            }

        }).catch((error) => {
            if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
        });
    }

    inserTag(campo) {
        var element = document.getElementById("summernote");
        element.value = element.value.substring(0, this.state.posicaomouse1)
            + campo.target.innerText
            + element.value.substring(this.state.posicaomouse2, element.value.length);
        this.state.form.mensagem = element.value;
    }

    click(campo) {
        var startPos = campo.target.selectionStart;
        var endPos = campo.target.selectionEnd;
        this.setState({ posicaomouse1: startPos, posicaomouse2: endPos });
    }

    handleChangeText(e) {
        this.defineMaxLenth();
        this.click(e);
        var texto = e.target.value;
        texto = texto.replace("tagselectorhtml:", "");
        this.state.form.mensagem = texto;
    }

    handleChangeName(e) {
        this.click(e);
        var texto = e.target.value;
        this.state.form.nome = texto;
    }

    handleChangeAssunto(e) {
        this.click(e);
        var texto = e.target.value;
        this.state.form.assunto = texto;
    }

    handleChangeUrl(e) {
        this.click(e);
        var urlInput = e.target.value;
        this.state.form.url = urlInput;
    }

    defineMaxLenth() {
        const tamMaximoSemUrl = "160";
        const tamMaximoComUrl = "135";

        if (this.state.form.url) {
            if (this.state.form.url.length == 0) {
                this.setState({ ...this.state, maxLength: tamMaximoSemUrl });
            } else {
                this.setState({ ...this.state, maxLength: tamMaximoComUrl });
            }
        } else {
            this.setState({ ...this.state, maxLength: tamMaximoSemUrl });
        }
    }

    render() {
        const form = this.state.form;
        let mensagemPreVisualizar = form.mensagem ? form.mensagem : " ";
        if (this.state.form.url) {
            mensagemPreVisualizar = mensagemPreVisualizar.concat(" ").concat("{URL_ANEXADA}");
        }

        return (
            <div>
                <ModalPreview isOpen={this.state.modalPreviewIsOpen} toggle={this.handlePreviewToggle} preview={mensagemPreVisualizar} />
                <ModalSendTest isOpen={this.state.modalSendTestIsOpen} toggle={this.handleTestToggle} />

                {/* TITLE */}
                <Row className="mb-4">
                    <Column size="3">
                        <h2 className="fs-20 fw-600 text-body m-0">Editor HTML</h2>
                    </Column>

                    <Column size="9">
                        <div className="input-group d-block fs-14 text-right">
                            <button type="button" onClick={this.handlePreviewToggle} className="btn btn-link px-3">Pré-visualizar</button>                                                        

                            <button name="salvar" type="button" onClick={this.handleSave} className="btn btn-link px-3">Salvar</button>

                            <button name="salvarcontinuar" type="button" onClick={this.handleSave} className="btn btn-primary px-4">Salvar e avançar <Icon name="fa-chevron-right" className="ml-2" /></button>
                        </div>
                    </Column>
                </Row>

                {/* FORM */}
                <Row className="mb-3">
                    <Column size="9">
                        <IBox className="mb-0">
                            <div>
                                <label>Nome do Template</label>
                            </div>
                            <div>
                                <input onChange={this.handleChangeName} value={this.state.form.nome}></input>
                            </div>

                            <label className='mt-3'>Corpo do Template</label>

                            {/* Editor here */}
                            <div>
                                <TextArea id="summernote" maxLength={this.state.maxLength} value={this.state.form.mensagem} onChange={this.handleChangeText} />
                                <small className="form-text text-muted"><i className="fa fa-info-circle" style={{ fontSize: "15px" }}></i><br />A quantidade máxima de caracteres será determinada pela inserção da url.<br /><strong>Com URL: 135 caracteres. <br />Sem URL: 160 caracteres.</strong></small>
                            </div>

                        </IBox>
                    </Column>

                    <Column size="3" className="container">
                        <Row>
                            <Column size="12" className="py-3">

                                <TemplateSelector status={this.state} templates={this.state.templates} onClick={this.insereTemplate.bind(this)} />

                            </Column>
                        </Row>

                        <Row>
                            <Column size="12" className="py-3">

                                <TagSelectorHTML status={this.state} getCampanha={this.state.idCampanha} />

                            </Column>
                        </Row>

                        <Row>
                            <Column size="12">
                                <UrlCampanhaSms onChange={this.handleChangeUrl} value={this.state.form.url} />
                            </Column>
                        </Row>
                    </Column>
                </Row>


                {/* GO BACK */}
                <Row className="mb-5">
                    <Column size="12" className="mx-auto container">
                        <div className="d-flex justify-content-start">

                            <Return to={this.props.campanha.urlRetorno} width="130px" />

                        </div>
                    </Column>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, campanha: state.campanha };
}
function mapDispatchToProps(dispatch) {
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NovaEditorSms));
